class ScrollTop {
  constructor() {
    this.duration = 600;
    this.button = '.scrollTop';
    this.init();
  }

  animation() {
    // cancel if already on top
    const { duration } = this;
    if (document.scrollingElement.scrollTop === 0) return;
    const cosParameter = document.scrollingElement.scrollTop / 2;
    let scrollCount = 0;
    let oldTimestamp = null;
    document.scrollingElement.scrollTop = 0;
    
    function step(newTimestamp) {
      if (oldTimestamp !== null) {
        // if duration is 0 scrollCount will be Infinity
        scrollCount += Math.PI * (newTimestamp - oldTimestamp) / duration;
        if (scrollCount >= Math.PI) {
          document.scrollingElement.scrollTop = 0;
          return false;
        }
        document.scrollingElement.scrollTop = cosParameter + cosParameter * Math.cos(scrollCount);
      }
      oldTimestamp = newTimestamp;
      window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }

  handleScroll() {
    const { scrollTop } = document.scrollingElement;
    const { height } = window.screen;
    const button = document.querySelector(this.button);

    if (scrollTop > height) {
      button.classList.add('--active');
    } else {
      button.classList.remove('--active');
    }
  }

  hadleClick(e) {
    e.preventDefault();
    this.animation();
  }

  removeEvents() {
    document.querySelector(this.button).removeEventListener('click', (e) => this.hadleClick(e));
    document.removeEventListener('scroll', () => this.handleScroll());
  }

  setEvents() {
    this.removeEvents();
    document.querySelector(this.button).addEventListener('click', (e) => this.hadleClick(e));
    document.addEventListener('scroll', () => this.handleScroll());
    this.handleScroll();
  }

  init() {
    if (!document.body.contains(document.querySelector(this.button))) {
      const button = document.createElement('button');
      button.classList.add('scrollTop');
      document.body.appendChild(button);
      this.setEvents();
    }
  }
}

export default ScrollTop;
